module.exports = __webpack_public_path__ + "h5/img/E.50c93ecb.png";